<template>
    <!-- Texto largo con "Leer más": corta a unas líneas y abre con un botón.
         Si adentro hay un formulario (el admin editando con AdminTextoEditable)
         no corta nada. -->
    <div class="fx-rdw">
        <div ref="caja" :id="uid" :class="['fx-rd', { 'is-cut': largo && !abierto && !editando }]">
            <slot />
        </div>
        <button v-if="largo && !editando" type="button" class="fx-link fx-rd-more" :aria-expanded="String(abierto)" :aria-controls="uid" @click="abierto = !abierto">
            {{ abierto ? $t('ficha_nueva.read_less') : $t('ficha_nueva.read_more') }}
        </button>
    </div>
</template>

<script>
let n = 0;
export default {
    name: 'FxLeerMas',
    props: { alto: { type: Number, default: 220 } },
    data() { return { uid: `fx-rd-${++n}`, largo: false, abierto: false, editando: false }; },
    mounted() {
        this.medir();
        if (typeof ResizeObserver !== 'undefined') {
            this.ro = new ResizeObserver(() => this.medir());
            this.ro.observe(this.$refs.caja);
        }
        this.mo = new MutationObserver(() => this.medir());
        this.mo.observe(this.$refs.caja, { childList: true, subtree: true });
    },
    beforeDestroy() { if (this.ro) this.ro.disconnect(); if (this.mo) this.mo.disconnect(); },
    methods: {
        medir() {
            const c = this.$refs.caja; if (!c) return;
            this.editando = !!c.querySelector('form');
            // altura real del contenido (sin el corte)
            const prev = c.style.maxHeight; c.style.maxHeight = 'none';
            const h = c.scrollHeight; c.style.maxHeight = prev;
            this.largo = h > this.alto + 40;
        },
    },
};
</script>
